import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type RoleAssignmentView,
  type SearchRoleAssignmentsV1RoleAssignmentsGetData,
  type SearchRoleAssignmentsV1RoleAssignmentsGetError,
  searchRoleAssignmentsV1RoleAssignmentsGet,
} from '../../generated';

export type SearchRoleAssignmentsQueryVariables = SearchRoleAssignmentsV1RoleAssignmentsGetData['query'];

export type SearchRoleAssignmentsQuery = RoleAssignmentView[];

export const useSearchRoleAssignmentsQuery = <
  TData = SearchRoleAssignmentsQuery,
  TError = SearchRoleAssignmentsV1RoleAssignmentsGetError,
>(
  { organization_id }: SearchRoleAssignmentsQueryVariables,
  options?: Omit<UseQueryOptions<SearchRoleAssignmentsQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<SearchRoleAssignmentsQuery, TError, TData>({
    queryKey: useSearchRoleAssignmentsQuery.getKey({ organization_id }),
    queryFn: async () => {
      const { data } = await searchRoleAssignmentsV1RoleAssignmentsGet({
        query: { organization_id },
        throwOnError: true,
      });
      return data ?? [];
    },
    ...options,
  });
};

useSearchRoleAssignmentsQuery.getKey = (variables: SearchRoleAssignmentsQueryVariables) => [
  'SearchRoleAssignments',
  variables,
];

useSearchRoleAssignmentsQuery.fetcher = (
  { organization_id }: SearchRoleAssignmentsQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await searchRoleAssignmentsV1RoleAssignmentsGet({
      query: { organization_id },
      throwOnError: true,
    });
    return data ?? [];
  };
};
